import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import { STORAGE_KEYS } from './constants/storageKeys';
import { registerLogoutHandler } from './constants/api';
import { ToastContainer } from './components/Toast';

import LoginScreen from './screens/LoginScreen';
import ExpenseListScreen from './screens/ExpenseListScreen';
import ExpenseFormScreen from './screens/ExpenseFormScreen';
import EmpCreditListScreen from './screens/EmpCreditListScreen';
import EmpCreditFormScreen from './screens/EmpCreditFormScreen';
import ExpenseApprovalScreen from './screens/ExpenseApprovalScreen';
import ExpenseDetailScreen from './screens/ExpenseDetailScreen';

function App() {
  const [currentScreen, setCurrentScreen] = useState('Splash');
  const [screenParams, setScreenParams] = useState({});
  // Persist the admin-selected employee across sub-screens
  const [selectedEmp, setSelectedEmp] = useState({ id: null, name: '' });
  // Persist the expense list's scroll position across a Details visit (ref, not state — updated on every scroll tick)
  const listScrollRef = useRef(0);

  useEffect(() => {
    const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    if (token) {
      setCurrentScreen('ExpenseList');
    } else {
      setCurrentScreen('Login');
    }
  }, []);

  // Register a global 401 handler: any fetchWithAuth call that gets 401
  // will invoke this, which clears storage and redirects to Login.
  useEffect(() => {
    const unsubscribe = registerLogoutHandler(() => {
      setCurrentScreen('Login');
      setScreenParams({});
    });
    return unsubscribe;
  }, []);

  const navigate = (screen, params = {}) => {
    setCurrentScreen(screen);
    setScreenParams(params);
  };

  const goBack = () => {
    if (currentScreen === 'ExpenseForm' || currentScreen === 'EmpCreditList' || currentScreen === 'EmpCreditForm' || currentScreen === 'ExpenseApproval' || currentScreen === 'ExpenseDetail') {
      // Return to list, restoring the previously selected employee and scroll position
      navigate('ExpenseList', {
        preservedEmpId: selectedEmp.id,
        preservedEmpName: selectedEmp.name,
        preservedScrollTop: listScrollRef.current,
      });
    }
  };

  if (currentScreen === 'Splash') {
    return (
      <div className="app-shell" style={{ justifyContent: 'center', alignItems: 'center' }}>
        <div className="spinner spinner--gold" />
      </div>
    );
  }

  return (
    <>
      {currentScreen === 'Login' && (
        <LoginScreen onLoginSuccess={() => navigate('ExpenseList')} />
      )}
      {currentScreen === 'ExpenseList' && (
        <ExpenseListScreen
          navigate={navigate}
          onLogout={() => navigate('Login')}
          params={screenParams}
          onEmpChange={(id, name) => setSelectedEmp({ id, name })}
          onScrollCapture={(pos) => { listScrollRef.current = pos; }}
        />
      )}
      {currentScreen === 'ExpenseForm' && (
        <ExpenseFormScreen params={screenParams} onBack={goBack} />
      )}
      {currentScreen === 'EmpCreditList' && (
        <EmpCreditListScreen params={screenParams} onBack={goBack} />
      )}
      {currentScreen === 'EmpCreditForm' && (
        <EmpCreditFormScreen params={screenParams} onBack={goBack} />
      )}
      {currentScreen === 'ExpenseApproval' && (
        <ExpenseApprovalScreen onBack={goBack} />
      )}
      {currentScreen === 'ExpenseDetail' && (
        <ExpenseDetailScreen navigate={navigate} params={screenParams} onBack={goBack} />
      )}
      <ToastContainer />
    </>
  );
}

export default App;
